const skills = [
  {
    categoryName: 'languages',
    set: [
      {
        name: 'JS',
        value: 7
      },
      {
        name: 'PHP',
        value: 8
      },
      {
        name: 'SASS',
        value: 3
      },
      {
        name: 'CSS',
        value: 8
      },
      {
        name: 'Python',
        value: 5
      }
    ]
  },
  {
    categoryName: 'framework',
    set: [
      {
        name: 'Codeigniter',
        value: 8
      },
      {
        name: 'React',
        value: 3
      },
      {
        name: 'NodeJS',
        value: 5
      },
      {
        name: 'jQuery',
        value: 8
      },
      {
        name: 'Bootstrap',
        value: 7
      }
    ]
  },
  {
    categoryName: 'tools',
    set: [
      {
        name: 'Photoshop',
        value: 7
      },
      {
        name: 'Ilustrator',
        value: 3
      }
    ]
  },
  {
    categoryName: 'CMS',
    set: [
      {
        name: 'Wordpress',
        value: 7
      }
    ]
  }
];

export default skills;



// WEBPACK FOOTER //
// ./src/components/data/skills.js